module.exports = __webpack_public_path__ + "img/hobby.2491d36d.png";